import { render, staticRenderFns } from "./goSearch.vue?vue&type=template&id=baea3cba"
import script from "./goSearch.ts?vue&type=script&lang=js&external"
export * from "./goSearch.ts?vue&type=script&lang=js&external"
import style0 from "./goSearch.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports